export default [
  {
    path: '/peoples/main',
    name: 'PeoplesMain',
    component: () => import('@/views/peoples/index'),
    meta: {
      title: '人物传记'
    }
  },
  {
    path: '/peoples/list/:code',
    name: 'PeoplesList',
    component: () => import('@/views/peoples/list'),
    meta: {
      title: '音乐课堂'
    },
    props: true,
  },
  {
    path: '/peoples/detail/:id',
    name: 'PeoplesDetail',
    component: () => import('@/views/peoples/detail'),
    meta: {
      title: '名人传记'
    },
    props: true,
  }
]